import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FileText, Upload, Scale, ArrowLeft } from 'lucide-react';
import InvoicesTab from '@/components/admin/b2b/InvoicesTab';
import SageExportTab from '@/components/admin/b2b/SageExportTab';
import SageReconcilePanel from '@/components/admin/b2b/SageReconcilePanel';

// Dedicated admin area for the full sales audit overview: B2B invoices,
// consumer/retail invoices and credit notes in one filterable, downloadable list,
// plus the Sage 50 export / reconcile tool.
export default function AdminInvoices() {
  const [tab, setTab] = useState('audit');
  return (
    <div className="min-h-screen bg-[#0d0d0f] pt-16">
      <header className="py-12 px-6 lg:px-10 border-b border-white/5">
        <div className="max-w-6xl mx-auto">
          <Link to="/admin/dashboard" className="inline-flex items-center gap-2 text-white/30 hover:text-white text-xs font-bold tracking-widest mb-4 transition-colors">
            <ArrowLeft className="w-4 h-4" /> BACK TO DASHBOARD
          </Link>
          <div className="flex items-center gap-3 mb-2">
            <FileText className="w-6 h-6 text-primary" />
            <p className="text-primary text-xs font-bold tracking-widest">ORDERS &amp; CUSTOMERS</p>
          </div>
          <h1 className="text-white font-black text-2xl sm:text-4xl uppercase">Invoices &amp; Credits</h1>
          <p className="text-white/30 text-sm mt-1">A complete overview of every sales invoice and credit note — B2B and consumer — plus the Sage 50 export tool.</p>

          {/* Tabs */}
          <div className="flex gap-2 mt-6">
            <button
              onClick={() => setTab('audit')}
              className={`inline-flex items-center gap-1.5 px-4 py-2 text-[10px] font-bold tracking-widest border transition-colors ${tab === 'audit' ? 'border-primary bg-primary text-white' : 'border-white/15 text-white/50 hover:text-white hover:border-white/30'}`}
            >
              <FileText className="w-3.5 h-3.5" /> SALES AUDIT
            </button>
            <button
              onClick={() => setTab('sage')}
              className={`inline-flex items-center gap-1.5 px-4 py-2 text-[10px] font-bold tracking-widest border transition-colors ${tab === 'sage' ? 'border-primary bg-primary text-white' : 'border-white/15 text-white/50 hover:text-white hover:border-white/30'}`}
            >
              <Upload className="w-3.5 h-3.5" /> SAGE EXPORT
            </button>
            <button
              onClick={() => setTab('reconcile')}
              className={`inline-flex items-center gap-1.5 px-4 py-2 text-[10px] font-bold tracking-widest border transition-colors ${tab === 'reconcile' ? 'border-primary bg-primary text-white' : 'border-white/15 text-white/50 hover:text-white hover:border-white/30'}`}
            >
              <Scale className="w-3.5 h-3.5" /> RECONCILE
            </button>
          </div>
        </div>
      </header>

      <section className="px-6 lg:px-10 py-8 max-w-6xl mx-auto">
        {tab === 'audit' ? <InvoicesTab /> : tab === 'sage' ? <SageExportTab /> : <SageReconcilePanel />}
      </section>
    </div>
  );
}